import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

/** Design-mode tools (docs/agents/design-mode.md), kept out of the big
 * canonical map so it stays under the line cap. */
export const designToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [
    HOST_TOOL_NAMES.PUBLISH_DESIGN,
    (record) => {
      const count = Array.isArray(record.directions)
        ? record.directions.length
        : 0;
      return labelOnly(
        count > 1
          ? `Published ${count} design directions`
          : "Published a design",
      );
    },
  ],
  [
    HOST_TOOL_NAMES.SET_LIVE_DESIGN,
    (record) => {
      const version = toolInput.trimmed(record.version);
      return labelOnly(
        version
          ? `Pointed the design link at v${version}`
          : "Moved the design link",
      );
    },
  ],
];
